import { createBackendService, ClientType } from '@dtvgo/backend-service';

import { authInterceptor, loadCredentials } from '~/store/credentials';
import { profileToken } from '~/store/profile/data';
import { CLIENT_HEADERS_OPTIONS } from '~/utils/clientHeadersOptions';
import { LANGUAGE } from '~/utils/constants';
import { errorFactory } from '~/utils/errorFactory';
import { isConnected } from '~/utils/functions';

export const middleware = createBackendService({
  host: import.meta.env.VITE_MIDDLEWARE_HOST,
  getAccessTokenData: loadCredentials,
  ...CLIENT_HEADERS_OPTIONS,
  profileToken,
  clientType: ClientType.CHROMECAST,
  language: LANGUAGE,
  errorFactory,
  isConnected,
  authInterceptor,
});
